module.exports = __webpack_public_path__ + "static/NeueMontreal-Italic-112b1211f7db9444d4d5174650b1e296.woff2";